import { Button, Checkbox, Divider, Popover } from 'antd';
import styled from 'styled-components';
import WorldIcon from '../common/assets/svgIcons/WorldIcon';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { JSXElementConstructor, ReactElement, ReactNode, ReactPortal, useEffect, useRef, useState } from 'react';
import { greyColor, primaryColor, primaryFont, primaryHeadingColor, secondaryFont, wMBold, wMedium, scrollbar, maxWidth, retina, smMobile, driver, maxMobile, maxTablet } from '../../Utils/utilsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { actions as serviceLineActions } from '../../Slice/ServiceLinesSlice';
import { selectServicelineRegions } from '../../Selector/ServiceLinesSelector';
import { RegionEntry, RegionsResponse } from '../../Types/ServiceLinesTypes';
import classNames from 'classnames';
import { Filter } from '../../Types/FilterTypes';
import { SRIFiltersRequest } from '../../Types/SRITypes';
import { IsTablet } from 'Utils/UtilityFunctions';
const Wrapper = styled.div`
  .region-btn {
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${greyColor};
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    line-height: 20px;
    letter-spacing: -0.4px;
    &.applyFlag {
      background: rgb(222, 246, 230);
      color: ${primaryColor};
    }
    @media all and (max-width: ${maxWidth}), ${retina} {
      height: 32px;
      font-size: 12px;
      .region-icon {
        height: 16px;
        width: 16px;
        svg {
          height: 16px;
          width: 16px;
        }
      }
    }
    @media all and (max-width: ${maxTablet}) {
      height: 29px;
    }
    &:hover {
      color: ${greyColor} !important;
      border-color: ${primaryColor} !important;
    }
    .region-icon {
      height: 19px;
      width: 19px;
      svg {
        height: 19px;
        width: 19px;
      }
    }
  }
  .ant-popover {
    width: 275px;
    @media all and (max-width: ${smMobile}) {
      width: 240px;
    }
    .ant-popover-content {
      .ant-popover-inner {
        padding: 0px !important
      }
      .regions-section {
        .upper-part {
          .regions-header {
            padding: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left-side {
              display: flex;
              align-items: center;
              column-gap: 12px;
              .icon {
                height: 20px;
                width: 20px;
                svg {
                  height: 20px;
                  width: 20px;
                }
              }
              .text {
                color: ${primaryHeadingColor};
                font-family: ${secondaryFont};
                font-size: 28px;
                font-style: normal;
                font-weight: ${wMBold};
                line-height: 28px;
                letter-spacing: -0.452px;
                @media all and (max-width: ${smMobile}) {
                  font-size: 24px;
                  line-height: 22px;
                }
              }
            }
            .btn-div {
              height: 32px;
              border-radius: 8px;
              border: 1px solid #DADADA;
              background: ${primaryColor};
              padding: 9px 15px;
              color: #FFF;
              text-align: center;
              font-family: ${primaryFont};
              font-size: 14px;
              font-style: normal;
              font-weight: ${wMBold};
              line-height: 12px;
              cursor: pointer;
              &.disabled {
                opacity: 0.5;
                pointer-events: none;
              }
            }
          }
          .no-region {
            color: ${driver};
            text-align: center;
            font-size: 16px;
            font-weight: ${wMedium};
            font-family: ${primaryFont};
            letter-spacing: -0.4px;
            margin-top: -8px;
            @media all and (max-width: ${maxMobile}) {
              font-size: 14px;
            }
          }
        }
        .data-section {
          padding: 16px;
          border-radius: 0 0 6px 6px;
          background: #F8F8F8;
          min-height: 115px;
          max-height: 209px;
          ${scrollbar}
          .region-block {
            display: flex;
            flex-direction: column;
            .block-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .ant-checkbox-wrapper {
                .ant-checkbox-indeterminate {
                  .ant-checkbox-inner {
                    &::after {
                      display: none;
                    }
                  }
                }

              }
              .expand-arrow {
                margin-bottom: 10px;
                cursor: pointer;
              }
            }
            .region-children {
              margin-left: 25px;
            }
            .ant-checkbox-label {
              color: #67696A;
              font-family: ${primaryFont};
              font-size: 16px;
              font-weight: ${wMedium};
              line-height: normal;
              letter-spacing: -0.609px;
            }
          }
        }
      }
    }
  }
`;

type Props = {
  serviceLineId: number;
  filter: Filter[];
  dateRangeFilter?: SRIFiltersRequest;
  page: number;
  widgetName: string;
  customFilters: Filter[];
}

const defaultProps = {
  serviceLineId: 0,
  filter: [],
  page: 0,
  widgetName: '',
}
const SLRegions = function SLRegions(props: Props) {
  const { serviceLineId, filter, dateRangeFilter, page, widgetName, customFilters } = props;
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const SLRegionsData: RegionEntry[] = useSelector(selectServicelineRegions);
  const isTab = IsTablet();

  const allSelected = (data: RegionEntry[]) => {
    return Object.fromEntries(
      data.map(item => [item.region, item.subRegions])
    )
  }
  const initialSelectedRef = useRef<Record<string, string[]>>(allSelected(SLRegionsData))
  const [selected, setSelected] = useState<Record<string, string[]>>(initialSelectedRef.current);
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [apply, setApply] = useState<boolean>(false);


  const isRegionChecked = (region: string, subRegions: string[]) => selected[region]?.length === subRegions.length;
  const isRegionIndeterminate = (region: string, subRegions: string[]) => (selected[region]?.length ?? 0) > 0 && selected[region]?.length < subRegions.length;

  const onRegionToggle = (region: string, subRegions: string[]) => {
    setSelected(prev => ({
      ...prev,
      [region]: prev[region]?.length === subRegions.length ? [] : subRegions,
    }))
  };

  const onSubRegionToggle = (region: string, values: string[]) => {
    setSelected(prev => ({
      ...prev,
      [region]: values,
    }))
  }

  const toggleExpand = (region: string) => {
    setExpanded(prev => ({
      ...prev,
      [region]: !prev[region],
    }));
  }

  useEffect(() => {
    if (!SLRegionsData.length) return;

    const allSelected = Object.fromEntries(
      SLRegionsData.map(item => [item.region, item.subRegions])
    );
    initialSelectedRef.current = allSelected;
    setSelected(allSelected);

    const allSubRegions = Object.values(allSelected).flat();

    dispatch(serviceLineActions.setSelectedRegions(allSubRegions));

  }, [SLRegionsData])

  useEffect(() => {
    dispatch(serviceLineActions.getRegions({
      serviceLineId: serviceLineId,
    }))
  }, [])

  const hadChanges = JSON.stringify(selected) !== JSON.stringify(initialSelectedRef.current);

  const applyHandler = () => {
    setApply(true);
    const allSubRegions = Object.values(selected).flat();

    dispatch(serviceLineActions.setSelectedRegions(allSubRegions));

    const subRegionString = allSubRegions.join(",");

    dispatch(serviceLineActions.getServiceLineDetails({
      page: 1,
      id: serviceLineId,
      widget_name: widgetName,
      ...(filter.length > 0 && { filters: filter }),
      ...(dateRangeFilter && { dateRangeFilter }),
      ...(subRegionString && { regions: subRegionString }),
      ...(customFilters.length > 0 && { customFilters })
    }))
    initialSelectedRef.current = selected;
    setOpen(false);
  }
  const content = (
    <div className='regions-section'>
      <div className='upper-part'>
        <div className='regions-header'>
          <div className='left-side'>
            <div className='icon'>
              <WorldIcon />
            </div>
            <div className="text">Region</div>
          </div>
          <div
            role='button'
            className={classNames('btn-div', { disabled: !hadChanges || Object.values(selected).flat().length === 0 })}
            aria-label='region-apply'
            onClick={() => applyHandler()}
          >
            Apply
          </div>
        </div>
        {
          Object.values(selected).flat().length === 0 && (
            <div className='no-region'>
              Please Select One Region at Least
            </div>
          )
        }
      </div>
      <div className='data-section'>
        {
          SLRegionsData.map((region) => {
            const isOpen = expanded[region.region];
            return (
              <div className='region-block'>
                <div className='block-header'>
                  <Checkbox
                    className="region-parent"
                    key={region.region}
                    checked={isRegionChecked(region.region, region.subRegions)}
                    indeterminate={isRegionIndeterminate(region.region, region.subRegions)}
                    onChange={() => onRegionToggle(region.region, region.subRegions)}
                  >
                    {region.region}
                  </Checkbox>
                  <span className='expand-arrow' onClick={() => toggleExpand(region.region)}>{isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}</span>
                </div>
                {isOpen && (
                  <Checkbox.Group
                    value={selected[region?.region] ?? []}
                    onChange={(vals) => onSubRegionToggle(region?.region, vals as string[])}
                  >
                    <div className='region-children'>
                      {region.subRegions.map((sub) => (
                        <Checkbox
                          key={sub}
                          value={sub}
                        >
                          {sub}
                        </Checkbox>
                      ))}
                    </div>
                  </Checkbox.Group>
                )}
              </div>
            )
          })
        }
      </div>
    </div>
  )
  return (
    <Wrapper className='service-line-regions'>
      <Popover
        open={open}
        onOpenChange={(newOpen) => setOpen(newOpen)}
        placement='bottomLeft'
        content={content}
        trigger="click"
        autoAdjustOverflow={false}
        getPopupContainer={(triggerNode) => triggerNode.parentElement!}
        arrow={false}
        zIndex={1000}
      >
        <Button className={classNames('region-btn', { applyFlag: apply })}>
          <div className='region-icon'>
            <WorldIcon color={(open || apply) ? primaryColor : greyColor} />
          </div>
          {
            !isTab && (
              <>
                <span className='text'>
                  Region
                </span>
                <Divider type='vertical' />
                {
                  !open ? (
                    <CaretDownOutlined />
                  ) : (
                    <CaretUpOutlined />
                  )
                }
              </>
            )
          }

        </Button>
      </Popover>
    </Wrapper>
  );
};
SLRegions.defaultProps = defaultProps;
export default SLRegions;